module.exports = "/images/vendor/desiigner-svg/svg/ui/arrow-bottom-left.svg?4209a31c292a2d90dcc6d6bfb9e27500";